<template>
	<layout>
		<vForm v-bind="{err}" @submit="reset">
			<vItem label="Email:" v-bind="{error: errors.email}">
				<vInput id="email" type="text" v-model="form.email" placeholder="Indtast din e-mail" required/>
			</vItem>
			<vItem label="Ny adgangskode:" v-bind="{error: errors.password}">
				<vInput id="password" type="password" v-model="form.password" placeholder="Indtast din adgangskode" required/>
			</vItem>
			<vItem label="Bekræft ny adgangskode:" v-bind="{error: errors.password_confirmation}">
				<vInput id="password_confirmation" type="password" v-model="form.password_confirmation" placeholder="Indtast din adgangskode" required/>
			</vItem>

			<div class="button">
				<btn tag="button" type="submit">Reset adgangskode</btn>
			</div>
		</vForm>
	</layout>
</template>

<script>
import {get} from "lodash";
import {vForm, vItem, vInput} from "@/components/form";
import btn from "@/components/button.vue";
import layout from "./layout.vue";

export default {
	components: {layout, vForm, vItem, vInput, btn},
	data() {
		return {
			err: {},

			form: {
				email: "",
				password: "",
				password_confirmation: ""
			}
		}
	},
	computed: {
		errors: (t) => get(t.err, "errors", {}),
		id: (t) => t.$route.params.id
	},
	methods: {
		async reset() {
			try {
				await this.$axios.post("admin/password/reset", {...this.form, token: this.id}, {customErr: true});
				this.$router.push({name: "login"});
			} catch(err) {
				this.err = get(err, "response.data", {});
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.button {
	width: 100%;
	text-transform: uppercase;
	height: 50px;
}
</style>
